import { useCallback } from 'react';

import { useReckonOneUIPreferences } from './useReckonOneUIPreferences';

/**
 * Fast mode state, backed by the user's persisted UI preferences
 * (`fastEntry`).
 */
export const useFastMode = () => {
  const uiPreferences = useReckonOneUIPreferences();
  const enabled = uiPreferences.preferences?.fastEntry ?? false;

  const onToggle = useCallback(() => {
    uiPreferences.updatePreferences({ fastEntry: !enabled });
  }, [enabled, uiPreferences]);

  return { enabled, onToggle };
};
